import React, { useState, useEffect } from 'react';

export default function LegalPages() {
  const [activeTab, setActiveTab] = useState('privacy');

  // ✅ Auto-detect tab from URL
  useEffect(() => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('terms')) setActiveTab('terms');
  }, []);

  return (
    <div className="min-h-screen bg-[#020617] text-slate-300 p-6 md:p-20 font-sans">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 border-b border-white/10 pb-6 gap-6">
          <div>
            <h1 className="text-white text-3xl font-black italic tracking-tighter uppercase">Legal Center</h1>
            <p className="text-blue-500 text-[10px] font-black tracking-[5px] uppercase">Digitoly Compliance v1.1</p>
          </div>
          <div className="flex bg-white/5 p-1 rounded-xl border border-white/5 w-full md:w-auto">
            <button 
              onClick={() => setActiveTab('privacy')}
              className={`flex-1 md:flex-none px-6 py-2 rounded-lg text-[10px] font-black transition-all ${activeTab === 'privacy' ? 'bg-white text-black' : 'text-gray-500'}`}
            >
              PRIVACY POLICY
            </button>
            <button 
              onClick={() => setActiveTab('terms')}
              className={`flex-1 md:flex-none px-6 py-2 rounded-lg text-[10px] font-black transition-all ${activeTab === 'terms' ? 'bg-white text-black' : 'text-gray-500'}`}
            >
              TERMS OF SERVICE
            </button>
          </div>
        </div>

        <div className="bg-white/5 border border-white/10 p-8 md:p-12 rounded-[40px] leading-relaxed text-sm shadow-2xl">
          {activeTab === 'privacy' ? (
            <div className="space-y-6">
              <h2 className="text-white font-bold text-xl italic tracking-tight">Privacy Policy</h2>
              <p className="text-slate-500 text-xs uppercase font-bold tracking-widest">Last Updated: April 2026</p>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">1. Data Collection</h3>
                <p>We collect minimal information required to provide QR services. This includes email addresses provided via lead forms and scan metadata (IP address, device type, and approximate location) to provide analytics to our users.</p>
              </section>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">2. Transparency</h3>
                <p>Lead data collected through our dynamic QR forms is shared only with the specific account holder who created that QR code. We do not sell data to third-party brokers.</p>
              </section>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">3. Legal Inquiries</h3>
                <p>For data removal requests or privacy concerns, please contact us at <span className="text-white font-bold">connect@digitoly.com</span>.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">4. Data Retention</h3>
                <p>We retain lead data for a maximum of 2 years to allow users to access historical analytics. After this period, data is automatically deleted from our active databases.</p>
              </section>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">5. User Rights</h3>
                <p>Users have the right to request deletion of their personal data. To do so, please send an email to <span className="text-white font-bold">connect@digitoly.com</span>.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">6. User Data Deletion</h3>
                <p>Users may request the deletion of their personal data at any time. To request data removal, please send an email to connect@digitoly.com with the subject line "Data Deletion Request." We will process your request and delete all associated personal information from our active databases within 30 days.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-6">
              <h2 className="text-white font-bold text-xl italic tracking-tight">Terms of Service</h2>
              <p className="text-slate-500 text-xs uppercase font-bold tracking-widest">Last Updated: April 2026</p>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">1. Acceptable Use</h3>
                <p>Users are strictly prohibited from creating QR codes that link to phishing sites, malware, illegal content, or deceptive redirects. Digitoly employs automated scanning to detect and disable malicious links.</p>
              </section>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">2. Account Termination</h3>
                <p>We reserve the right to terminate any account found using our service for fraudulent activities or data harvesting without proper disclosure.</p>
              </section>

              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">3. Contact Support</h3>
                <p>Technical or legal support can be reached at <span className="text-white font-bold">connect@digitoly.com</span>.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">4. Limitation of Liability</h3>
                <p>Digitoly is not liable for any damages arising from the use or misuse of our QR code services, including but not limited to data loss, business disruption, or legal consequences from third-party content.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">5. Changes to Terms</h3>
                <p>We may update our Terms of Service periodically. Continued use of our services after changes constitutes acceptance of the new terms.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">6. Governing Law</h3>
                <p>These terms are governed by the laws of the jurisdiction in which Digitoly operates, without regard to conflict of law principles.</p>
              </section>
              <section className="space-y-3">
                <h3 className="text-blue-400 font-black text-xs uppercase tracking-widest">7. Contact Information</h3>
                <p>For legal inquiries, please contact us at <span className="text-white font-bold">connect@digitoly.com</span>.</p>
              </section>
              </div>
          )}
        </div>

        <div className="mt-10 text-center">
            <a href="/" className="text-[10px] font-black text-gray-500 hover:text-blue-500 transition-colors uppercase tracking-[8px] px-6 py-3 border border-white/5 rounded-full">← Back to Generator</a>
        </div>
      </div>
    </div>
  );
}